import { render, staticRenderFns } from "./ScreenTabs.vue?vue&type=template&id=335907fc&scoped=true"
import script from "./ScreenTabs.vue?vue&type=script&lang=js"
export * from "./ScreenTabs.vue?vue&type=script&lang=js"
import style0 from "./ScreenTabs.vue?vue&type=style&index=0&id=335907fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335907fc",
  null
  
)

export default component.exports